import $axios from "../../plugins/axios";
import $dayjs from "../../plugins/dayjs";
import { RoleEnum } from "../../utils/types";

const state = {
  users: [],
};

const getters = {
  getUser: (state) => (userId) =>
    state.users.find((user) => user.id === userId),
  getUsers: (state) => state.users,
  getAboutToExpireUsers: (state, getters, rootState, rootGetters) =>
    state.users.filter((user) => {
      const expiresAt = $dayjs(user.expires_at);
      const daysUntilExpiry = expiresAt.diff($dayjs(), "days");
      const currentUserRole = rootGetters["authentication/getRole"];
      if (currentUserRole === RoleEnum.APPLICATION_ADMIN) {
        return (
          expiresAt.isValid() &&
          daysUntilExpiry <= 90 &&
          user.role !== RoleEnum.APPLICATION_ADMIN
        );
      }
      if (currentUserRole === RoleEnum.ACCOMMODATION_ADMIN) {
        return (
          expiresAt.isValid() &&
          daysUntilExpiry <= 90 &&
          user.role !== RoleEnum.ACCOMMODATION_ADMIN
        );
      }
    }),
};

const mutations = {
  commitUsers: (state, users) => {
    state.users = users;
  },
};

const actions = {
  async fetchUsers(context) {
    if (context.state.users.length) return;
    let response = await $axios.get("/v1/users");
    context.commit("commitUsers", response.data);
  },
  createUser(context, newUser) {
    context.commit("commitUsers", [...context.state.users, newUser]);
  },
  updateUser(context, updatedUser) {
    let users = context.state.users.filter(
      (user) => user.id !== updatedUser.id
    );
    users.push(updatedUser);
    context.commit("commitUsers", users);
  },
  updateUsers(context, updatedUsers) {
    let users = context.state.users.filter(
      (user) => !updatedUsers.some((updatedUser) => updatedUser.id === user.id)
    );
    users.push(...updatedUsers);
    context.commit("commitUsers", users);
  },
  deleteUser(context, userId) {
    context.commit("commitUsers", [
      ...context.state.users.filter((user) => user.id !== userId),
    ]);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
